import React, { useState, useRef, useEffect } from 'react';
import { getFromCookies } from '../utils/cookieUtils';
import { openDB } from 'idb';
import { FaRobot, FaPaperPlane, FaTimes } from 'react-icons/fa';

const initialMessages = [
  { sender: 'assistant', text: 'Hi! I am your AI assistant. How can I help you today?' }
];

const AIChatAssistant = () => {
  // Unique user/device id
  const userId = (getFromCookies() && getFromCookies().uniqueString) || 'guest';

  // IndexedDB helpers
  const dbName = 'merchants';
  const storeName = 'chat';
  const initDB = async () => {
    return await openDB(dbName, 2, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName, { keyPath: 'userId' });
        }
      }
    });
  };

  const saveMessages = async (messages) => {
    const db = await initDB();
    await db.put(storeName, { userId, messages });
  };

  const loadMessages = async () => {
    const db = await initDB();
    const entry = await db.get(storeName, userId);
    return entry && entry.messages ? entry.messages : initialMessages;
  };
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState(initialMessages);
  // Load chat history on mount
  useEffect(() => {
    loadMessages().then(msgs => setMessages(msgs));
  }, []);
  const [input, setInput] = useState('');
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (open && messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    // Save messages to IndexedDB whenever they change
    saveMessages(messages);
  }, [messages, open]);

  const handleSend = () => {
    if (!input.trim()) return;
    const userMsg = { sender: 'user', text: input };
    setMessages([...messages, userMsg]);
    setInput('');

    // Gemini expects a different payload
    const apiUrl = process.env.REACT_APP_CHAT_API_KEY;
    const payload = {
      contents: [
        { role: 'user', parts: [{ text: input }] }
      ]
    };

    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => res.json())
      .then(data => {
        // Gemini response parsing
        const aiText =
          data.candidates && data.candidates[0] && data.candidates[0].content && data.candidates[0].content.parts && data.candidates[0].content.parts[0] && data.candidates[0].content.parts[0].text
            ? data.candidates[0].content.parts[0].text
            : 'Sorry, I could not process your request.';
        setMessages(msgs => [...msgs, { sender: 'assistant', text: aiText }]);
      })
      .catch(() => {
        setMessages(msgs => [...msgs, { sender: 'assistant', text: 'Sorry, there was an error connecting to AI.' }]);
      });
  };

  return (
    <>
      <div className="ai-chat-icon" onClick={() => setOpen(true)}>
        <FaRobot size={28} /> 
      </div>
      {open && (
        <div className="ai-chat-modal">
          <div className="ai-chat-header">
            <span><FaRobot /> Merchant AI Assistant</span>
            <FaTimes className="ai-chat-close" onClick={() => setOpen(false)} />
          </div>
          <div className="ai-chat-messages">
            {messages.map((msg, idx) => (
              <div key={idx} className={`ai-chat-message ${msg.sender}`}>
                <div className={`ai-chat-bubble ${msg.sender}`}>{msg.text}</div>
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>
          <div className="ai-chat-input-row">
            <input
              type="text"
              value={input}
              onChange={e => setInput(e.target.value)}
              placeholder="Type your message..."
              onKeyDown={e => e.key === 'Enter' && handleSend()}
              className="ai-chat-input"
            />
            <button className="ai-chat-send" onClick={handleSend}><FaPaperPlane /></button>
          </div>
        </div>
      )}
    </>
  );
};

export default AIChatAssistant;
